import { useGlobalStore } from "#src/store/global";

// @en Defines a global variable to track how many requests are currently in progress
let requestCount = 0;

export const globalProgress = {
	/**
	 * @en Starts a request
	 *
	 * @en If the request count is 0, show the global loading animation and increment the request count by 1.
	 */
	start() {
		if (requestCount === 0) {
			// @en Show the global loading animation
			useGlobalStore.getState().openGlobalSpin();
		}
		// @en Increment the request count by 1
		requestCount++;
	},

	/**
	 * @en Callback function after a request is complete
	 *
	 * @description @en Decrements the request count by 1 and ensures the request count does not fall below 0.
	 * @en If the request count is 0, hide the global loading animation.
	 */
	done() {
		// @en Decrement the request count by 1, but ensure it does not fall below 0
		requestCount = Math.max(requestCount - 1, 0);
		if (requestCount === 0) {
			// @en Hide the global loading animation
			useGlobalStore.getState().closeGlobalSpin();
		}
	},

	/**
	 * @en Forces the completion of all requests
	 *
	 * @en Sets the request count directly to 0 and hides the global loading animation
	 */
	forceFinish() {
		// @en Set the request count directly to 0
		requestCount = 0;
		// @en Hide the global loading animation
		useGlobalStore.getState().closeGlobalSpin();
	},
};
